function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object) {
    var h = require("panel").h;
    const classes = $helpers.getComponentClasses(`mp-button-`);;
    const isPrimary = $attr(`theme`) === 'primary' || classes['mp-button-primary'];;
    const isSecondary = $attr(`theme`) === 'secondary' || classes['mp-button-secondary'];;
    const isTertiary = $attr(`theme`) === 'tertiary' || classes['mp-button-tertiary'];;
    const iconOnly = !$component.textContent.trim() && !!$attr(`icon`);;
    const isDestructive = $attr(`destructive`);;
    const isPressed = $attr(`pressed`);
    return {
      value: (h("div", {
        "attrs": $helpers.getButtonAttrs(),
        "class": Object.assign({}, Object.assign(classes, {
          'mp-button-with-icon': !!$attr(`icon`) && !iconOnly,
          'mp-button-icon-only': iconOnly,
          'mp-button-primary': isPrimary,
          'mp-button-secondary': isSecondary,
          'mp-button-tertiary': isTertiary,
          'mp-button-destructive': isDestructive,
          'mp-button-pressed': isPressed,
        }), {
          'mp-button-container': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-button-animation-layer': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-button-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`icon`) === `spinner`) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
              "attrs": {
                color: isPrimary && !$attr(`disabled`) ? `white` : `blue`
              },
            }));;
            return __jade_nodes
          }).call(this)) : ($attr(`icon`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("svg-icon", {
              "attrs": {
                icon: $attr(`icon`)
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!(iconOnly)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("slot"));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;